export default __webpack_public_path__ + "static/media/blog-placeholder.46f5e935.jpg";